import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useContext, useEffect, useReducer, useState } from "react";
import { Badge } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { Store } from "../Store";
import AnswersDetailsModal from "../components/AnswersDetailsModal";
import ChangePriceModal from "../components/ChangePriceModal";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import SepetItemEditor from "../components/SepetItemEditor";
import SiparisBolModal from "../components/SiparisBolModal";
import useAxios from "../hooks/useAxios";
import useUsers from "../hooks/useUsers";
import {
  getError,
  getPrintAreaHtml,
  getTimeExpr,
  round2,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";
import CartScreenTouchItem from "./CartScreenTouchItem";
import CartScreenTouchItemRelative from "./CartScreenTouchItemRelative";

const reducer = (state, action) => {
  switch (action.type) {
    case "CREATE_REQUEST":
      return { ...state, loading: true };
    case "CREATE_SUCCESS":
      return { ...state, loading: false };
    case "CREATE_FAIL":
      return { ...state, loading: false };
    case "PREVNEXT_REQUEST":
      return { ...state, loadingPrevNext: true };
    case "PREVNEXT_SUCCESS":
      return { ...state, loadingPrevNext: false, deneme: 1 };
    case "PREVNEXT_FAIL":
      return { ...state, loadingPrevNext: false };
    case "UPDATE_REQUEST":
      return { ...state, loadingUpdate: true };
    case "UPDATE_SUCCESS":
      return { ...state, loadingUpdate: false };
    case "UPDATE_FAIL":
      return { ...state, loadingUpdate: false };
    default:
      return state;
  }
};

export default function CartScreenTouch(props) {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const axios = useAxios();
  const [isProcessing, setIsProcessing] = useState(false);
  useUsers();
  const [{ loading, loadingUpdate }, dispatch] = useReducer(reducer, {
    loading: false,
    loadingPrevNext: false,
    loadingUpdate: false,
  });
  const {
    tableTemp: table,
    isCustomerOrder,
    height,
    readOnlyCart,
    mobileCart,
    historic,
    setCartShow,
  } = props;
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { carts, userInfo, users = [], tableTypesAll: tableTypes = [] } = state;
  const [cart, setCart] = useState({ cartItems: [] });
  const [cachePayment, setCachePayment] = useState("");
  const [posPayment, setPosPayment] = useState("");
  const [tipPayment, setTipPayment] = useState("");
  const [ozetle, setOzetle] = useState(props.ozetle || false);
  const [showChangePrice, setShowChangePrice] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [siparisDivideLoading, setSiparisDivideLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [showDivideItem, setShowDivideItem] = useState(false);
  const [divideFirstPart, setDivideFirstPart] = useState(0);
  const [divideSecondPart, setDivideSecondPart] = useState(0);
  const [isPartialPayment, setIsPartialPayment] = useState(false);
  const [showAnswerDetails, setShowAnswerDetails] = useState(false);
  const [answers, setAnswers] = useState([]);
  const [selectedProductPrice, setSelectedProductPrice] = useState(
    selectedProduct.price || 0
  );
  const [priceChangeRate, setPriceChangeRate] = useState(5);
  const [passedTime, setPassedTime] = useState();
  const [showAddCard, setShowAddCard] = useState(false);
  const { pathname, search } = useLocation();
  const sp = new URLSearchParams(search);
  const redirect = sp.get("redirect") || "";

  const handlePrint = async () => {
    if (isProcessing) return; // Prevent multiple triggers
    setIsProcessing(true);

    const printContentX = document.getElementById("print-area");

    const newDivHTML = getPrintAreaHtml(
      userInfo,
      cart.summaryCartItems,
      cart,
      window.location.origin
    );

    // Create a deep copy of the print content
    const printContent = printContentX.cloneNode(true);

    printContent.insertAdjacentHTML("afterbegin", newDivHTML);

    printContent.style.position = "absolute";
    printContent.style.top = "-9999px"; // Move it vertically off the screen
    printContent.style.left = "-9999px"; // Move it horizontally off the screen
    printContent.style.width = "auto"; // Ensure proper rendering
    printContent.style.height = "auto"; // Ensure proper rendering
    printContent.id = "print-area-copy";

    // Append the hidden copy next to the original
    printContentX.parentNode.insertBefore(
      printContent,
      printContentX.nextSibling
    );

    if (printContent) {
      try {
        // Use html2canvas to capture the div as a canvas
        const canvas = await html2canvas(printContent, { scale: 2 }); // Double the resolution
        const imgData = canvas.toDataURL("image/png");

        // Define the target paper size in mm
        const paperWidth = 58; // Fixed paper width in mm
        const paperHeight = 100; // Fixed paper height in mm
        const pdf = new jsPDF("p", "mm", [paperWidth, paperHeight]);

        // Fit the image to the page
        const aspectRatio = canvas.width / canvas.height;
        let imgWidth = paperWidth; // Fit width
        let imgHeight = paperWidth / aspectRatio; // Adjust height to maintain aspect ratio

        if (imgHeight > paperHeight) {
          imgHeight = paperHeight;
          imgWidth = paperHeight * aspectRatio;
        }

        // Add the image to the PDF
        pdf.addImage(
          imgData,
          "PNG",
          0,
          0,
          imgWidth,
          imgHeight,
          undefined,
          "FAST"
        );

        console.log(`image width: ${imgWidth} image Height: ${imgHeight}`);

        // Open the print dialog
        pdf.autoPrint();

        // Open the PDF in a new window or send it directly to the printer
        const blob = pdf.output("blob");
        const url = URL.createObjectURL(blob);

        // Open in a new window (this will trigger the print)
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = url;
        document.body.appendChild(iframe);

        iframe.onload = function () {
          iframe.contentWindow.print();
        };
      } catch (error) {
        console.error("Error generating PDF:", error);
      } finally {
        setIsProcessing(false);
      }
    } else {
      alert("No content found to print!");
      setIsProcessing(false);
    }
  };

  const odemeyiAlHandler = async () => {
    if (readOnlyCart) {
      return;
    }
    if (isPartialPayment) {
      try {
        if (!cart.isStaffMeal) {
          if (Number(cachePayment) + Number(posPayment) !== cart.partialPrice) {
            toast.error("Lütfen nakit ve pos ödeme bilgilerini giriniz!");
            return;
          }
        }
        const isTherePartialPayment =
          cart.cartItems.filter((c) => c.isPartialPayment && !c.isPartialPaid)
            .length > 0;

        if (!isTherePartialPayment) {
          toast.error("Lütfen kısmi ödemesi yapılacak ürünleri seçiniz!");
          return;
        }

        dispatch({ type: "UPDATE_REQUEST" });

        const { data } = carts[table - 1].tableCode
          ? { data: carts[table - 1] }
          : await axios.get(`/api/customer?tableNum=${table}`);

        await axios.put(`/api/customer/orders/partialpay/${data.tableCode}`, {
          items: cart.cartItems
            .filter((c) => c.isPartialPayment && !c.isPartialPaid)
            .map((c) => c.itemCode),
          partialCache: !cachePayment ? 0 : cachePayment,
          partialPOS: !posPayment ? 0 : posPayment,
        });

        dispatch({ type: "UPDATE_SUCCESS" });
        setIsPartialPayment(false);
        toast.success("Kısmi ödemeniz onaylandı!");
        setCartShow && setCartShow(false);
      } catch (err) {
        dispatch({ type: "UPDATE_FAIL" });
      }
    } else {
      placeOrderHandler();
    }
  };

  useEffect(() => {
    if (cart.cartItems.length > 0) {
      setPassedTime(getTimeExpr(new Date(cart.cartItems[0].createdAt)));

      let secTimer = setInterval(() => {
        setPassedTime(getTimeExpr(new Date(cart.cartItems[0].createdAt)));
      }, 1000 * 60);

      return () => clearInterval(secTimer);
    }
  }, [table, cart]);

  const placeOrderHandler = async () => {
    try {
      if (!cart.isStaffMeal) {
        if (Number(cachePayment) + Number(posPayment) !== cart.totalPrice) {
          toast.error("Lütfen nakit ve pos ödeme bilgilerini giriniz!");
          return;
        }
      }

      dispatch({ type: "CREATE_REQUEST" });

      await axios.post("/api/orders", {
        orderItems: cart.cartItems,
        shippingAddress: cart.shippingAddress,
        tableNum: table,
        tableCode: cart.tableCode,
        clientCode: cart.clientCode,
        cachePayment: !cachePayment
          ? cart.partialCache
            ? cart.partialCache
            : 0
          : cachePayment + (cart.partialCache ? cart.partialCache : 0),
        posPayment: !posPayment
          ? cart.partialPOS
            ? cart.partialPOS
            : 0
          : posPayment + (cart.partialPOS ? cart.partialPOS : 0),
        tipPayment: !tipPayment ? 0 : tipPayment,
        isStaffMeal: cart.isStaffMeal,
        description: cart.description,
        orderCode: cart.orderCode,
        tableType: cart.tableType ? cart.tableType : null,
        onBusinessUser: cart.onBusinessUser ? cart.onBusinessUser : null,
      });

      dispatch({ type: "CREATE_SUCCESS" });
      ctxDispatch({
        type: "ORDER_APPROVED",
        payload: { tableNum: table },
      });
      setCart({
        cartItems: [],
        summaryCartItems: [],
        description: "",
        totalPrice: 0,
        totalCount: 0,
        tableNum: table,
      });
      toast.success("Ödeme başarılı bir şekilde alındı!");
      setCartShow && setCartShow(false);
    } catch (err) {
      dispatch({ type: "CREATE_FAIL" });
      toast.error(getError(err), { autoClose: 5000 });
    }
  };

  const ikramEtHandler = (itemCode, isIkram) => {
    ctxDispatch({
      type: "CART_GIFT_ITEM",
      payload: {
        isGift: isIkram,
        itemCode: itemCode,
        tableNum: table,
      },
    });
  };

  const updateCartHandler = async (quantity) => {
    try {
      const itemCode = uuidv4();

      const { data } = carts[table - 1].tableCode
        ? { data: carts[table - 1] }
        : await axios.get(`/api/customer?tableNum=${table}`);

      const cartItems = !isTabletOrMobile
        ? [
            {
              ...selectedProduct,
              quantity,
              createdAt: new Date().toISOString(),
              feature:
                selectedProduct.features.length === 1
                  ? selectedProduct.features[0]
                  : selectedProduct.feature,
              tableNum: table,
              itemCode: itemCode,
              tableCode: data.tableCode,
              delivered: true,
            },
          ]
        : [
            {
              ...selectedProduct,
              quantity,
              createdAt: new Date().toISOString(),
              feature:
                selectedProduct.features.length === 1
                  ? selectedProduct.features[0]
                  : "",
              tableNum: table,
              itemCode: itemCode,
            },
          ];

      if (!isTabletOrMobile) {
        await axios.put(`/api/customer/${data.tableCode}`, {
          cartItems,
          customerName: carts[table - 1].description,
          clientCode: userInfo.clientCode,
          orderCode: uuidv4(),
          businessOwner:
            userInfo.isHelpDesk && userInfo.client
              ? userInfo.client.businessOwner
              : userInfo.membership.businessOwner,
        });
      }

      /*ctxDispatch({
        type: "CART_ADD_ITEM",
        payload: cartItems[0],
      });*/

      toast.success(
        quantity +
          " adet " +
          (selectedProduct.features.length > 0
            ? selectedProduct.features[0].name + " "
            : "") +
          selectedProduct.name +
          " sepete eklendi"
      );
    } catch (err) {
      toast.error(getError(err));
    }
  };

  const decrementCartItemHandler = async (item, index, decrementValue = 1) => {
    try {
      dispatch({ type: "UPDATE_REQUEST" });
      await axios.put(`/api/customer/orders/item/${item.itemCode}`, {
        quantity: item.quantity - decrementValue,
      });

      /*ctxDispatch({
        type: "CART_DECREMENT_ITEM",
        payload: { ...item, tableNum: table, index, decrementValue },
      });*/
      dispatch({ type: "UPDATE_SUCCESS" });
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "UPDATE_FAIL" });
    }
  };
  const incrementCartItemHandler = async (item, index, incrementValue = 1) => {
    try {
      dispatch({ type: "UPDATE_REQUEST" });
      await axios.put(`/api/customer/orders/item/${item.itemCode}`, {
        quantity: item.quantity + incrementValue,
      });

      /*ctxDispatch({
        type: "CART_INCREMENT_ITEM",
        payload: { ...item, tableNum: table, index, incrementValue },
      });*/
      dispatch({ type: "UPDATE_SUCCESS" });
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "UPDATE_FAIL" });
    }
  };
  const removeItemHandler = async (item, i) => {
    item.index = i;

    try {
      setShowAddCard(false);

      dispatch({ type: "UPDATE_REQUEST" });
      await axios.delete(`/api/customer/orders/item/${item.itemCode}`);

      /*ctxDispatch({
        type: "CART_REMOVE_ITEM",
        payload: { item: item, tableNum: table },
      });*/
      dispatch({ type: "UPDATE_SUCCESS" });
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "UPDATE_FAIL" });
    }
  };

  const editHandler = (index) => {
    ctxDispatch({
      type: "CART_ITEM_EDITABLE",
      payload: { index, tableNum: table },
    });
  };

  const divideCartItemHandler = async (index, isIkram) => {
    setSiparisDivideLoading(true);
    await decrementCartItemHandler(
      selectedProduct,
      selectedIndex,
      divideSecondPart
    );
    await updateCartHandler(divideSecondPart);
    setShowDivideItem(false);
    setSiparisDivideLoading(false);
  };

  useEffect(() => {
    setCachePayment("");
    setPosPayment("");
    setTipPayment("");
  }, [table, cart]);

  useEffect(() => {
    const cartsfinal = readOnlyCart || carts[table - 1];
    if (table > 0) {
      setCart({
        ...cartsfinal,
        summaryCartItems: [
          ...getSummaryCartItems(
            cartsfinal.cartItems,
            historic || false,
            false
          ),
          ...getSummaryCartItems(cartsfinal.cartItems, historic || false, true),
        ],
        description: cartsfinal.description ? cartsfinal.description : "",
        tableType: cartsfinal.tableType ? cartsfinal.tableType : "",
        onBusinessUser: cartsfinal.onBusinessUser
          ? cartsfinal.onBusinessUser
          : "",
        totalPrice: round2(
          cartsfinal.cartItems
            .filter((x) => !x.isGift && !x.isPartialPaid)
            .reduce(
              (a, c) =>
                a +
                c.quantity * (c.feature ? c.feature.price + c.price : c.price) +
                (c.answers
                  ?.flatMap((a) => a.answers)
                  .filter((a) => a && !a.product)
                  .reduce((a, c) => a + c.cost, 0) || 0),
              0
            )
        ),
        totalCount: cartsfinal.cartItems
          .filter((x) => !x.isGift && !x.isPartialPaid)
          .reduce((a, c) => a + c.quantity, 0),
        partialPrice: round2(
          cartsfinal.cartItems
            .filter((x) => !x.isGift && x.isPartialPayment && !x.isPartialPaid)
            .reduce(
              (a, c) =>
                a +
                c.quantity * (c.feature ? c.feature.price + c.price : c.price) +
                (c.answers
                  ?.flatMap((a) => a.answers)
                  .filter((a) => a && !a.product)
                  .reduce((a, c) => a + c.cost, 0) || 0),
              0
            )
        ),
        partialCount: cartsfinal.cartItems
          .filter((x) => !x.isGift && x.isPartialPayment && !x.isPartialPaid)
          .reduce((a, c) => a + c.quantity, 0),
      });
    } else {
      setCart({
        cartItems: [],
        summaryCartItems: [],
        description: "",
        totalPrice: 0,
        totalCount: 0,
        tableNum: table,
      });
    }
  }, [table, carts, readOnlyCart]);

  const paymentPosChangeHandler = (e) => {
    if (
      Number(e.target.value) >
      (isPartialPayment ? cart.partialPrice : cart.totalPrice)
    ) {
      setPosPayment(isPartialPayment ? cart.partialPrice : cart.totalPrice);
      setCachePayment("");
    } else {
      setPosPayment(round2(e.target.value) === 0 ? "" : round2(e.target.value));
      setCachePayment(
        (isPartialPayment ? cart.partialPrice : cart.totalPrice) -
          round2(Number(e.target.value))
      );
    }
  };

  const paymentCacheChangeHandler = (e) => {
    if (isNaN(e.target.value)) {
      window.alert("Lutfen sayi giriniz");
      return;
    }
    if (
      Number(e.target.value) >
      (isPartialPayment ? cart.partialPrice : cart.totalPrice)
    ) {
      setCachePayment(isPartialPayment ? cart.partialPrice : cart.totalPrice);
      setPosPayment("");
    } else {
      setCachePayment(
        round2(Number(e.target.value)) === 0
          ? ""
          : round2(Number(e.target.value))
      );
      setPosPayment(
        (isPartialPayment ? cart.partialPrice : cart.totalPrice) -
          round2(Number(e.target.value))
      );
    }
  };

  return (
    <div
      className={
        readOnlyCart || mobileCart
          ? ""
          : "bg-light border border-secondary rounded touchPanelCompartment  p-1"
      }
      style={{
        display: "flex",
        flexDirection: "column",
        flexGrow: "2",
        height: height,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          margin: "0.3rem",
          padding: "0.3rem",
          position: "relative",
        }}
        className={`border border-dark rounded ${
          isTabletOrMobile ? "bg-white" : "bg-dark"
        }`}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          {cart.tableNum <= 300 && (
            <div>
              <Badge
                className="border border-success p-2 px-3"
                bg={
                  isTabletOrMobile ? "white text-success" : "dark text-success"
                }
                style={{ fontSize: "30px", position: "relative" }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "2px",
                    left: "2px",
                    fontSize: "12px",
                  }}
                >
                  No
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: "2px",
                    right: "2px",
                    fontSize: "12px",
                    writingMode: "vertical-rl",
                  }}
                >
                  {cart.description?.substring(0, 5)}
                </div>

                <div
                  style={{
                    position: "absolute",
                    bottom: "1px",
                    left: "2px",
                    fontSize: "11px",
                    fontFamily: "monospace",
                  }}
                >
                  {(users || [])
                    .find((u) => u._id === cart.onBusinessUser)
                    ?.name.substring(0, 5)}
                </div>

                {table}
              </Badge>
            </div>
          )}
          <div>
            <Button
              className="p-2 px-3 ms-2"
              variant={ozetle ? "outline-primary" : "outline-secondary"}
              onClick={() => {
                setOzetle(!ozetle);
                if (!ozetle) {
                  setIsPartialPayment(false);
                }
              }}
            >
              <i
                className={ozetle ? "fas fa-eye" : "fas fa-list"}
                style={{ fontSize: "30px" }}
              ></i>
            </Button>

            {readOnlyCart && (
              <Button
                variant="outline-secondary"
                className="p-2 px-3 ms-2"
                onClick={(e) => {
                  e.preventDefault();
                  handlePrint();
                }}
              >
                <i className="fas fa-print" style={{ fontSize: "30px" }}></i>
              </Button>
            )}

            {!cart.isStaffMeal && !readOnlyCart && (
              <Button
                className="p-2 px-3 ms-2"
                variant={
                  isPartialPayment ? "outline-primary" : "outline-secondary"
                }
                onClick={() => {
                  setIsPartialPayment(!isPartialPayment);
                  if (!isPartialPayment) {
                    setOzetle(false);
                  }
                }}
              >
                <i
                  style={{ fontSize: "30px" }}
                  className={
                    isPartialPayment
                      ? "fas fa-check-square"
                      : "fas fa-minus-square"
                  }
                ></i>
              </Button>
            )}
          </div>

          <div
            className={
              isTabletOrMobile
                ? "text-dark p-2 px-3 ms-2"
                : "text-white p-2 px-3 ms-2"
            }
          >
            <div className="small-font">
              {cart.cartItems.length > 0
                ? new Date(cart.cartItems[0].createdAt).toLocaleDateString(
                    "tr-TR"
                  )
                : ""}
            </div>
            {cart.cartItems.length > 0 && (
              <div className="small-font">{passedTime}</div>
            )}
          </div>
        </div>

        {!isTabletOrMobile &&
          cart.tableType &&
          tableTypes &&
          tableTypes
            .filter((tt) => tt.status)
            .find((u) => u._id === cart.tableType) && (
            <div>
              <img
                src={
                  (tableTypes || []).find((u) => u._id === cart.tableType)
                    ?.image
                }
                alt={
                  (tableTypes || []).find((u) => u._id === cart.tableType)?.name
                }
                className="me-3 border border-primary"
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "7px",
                }}
              />
            </div>
          )}

        {isTabletOrMobile && tableTypes && cart.tableType && (
          <div>
            <img
              src={
                (tableTypes || []).find((u) => u._id === cart.tableType)?.image
              }
              alt={
                (tableTypes || []).find((u) => u._id === cart.tableType)?.name
              }
              className="me-3 border border-primary"
              style={{
                width: "48px",
                height: "48px",
                position: "absolute",
                top: "5px",
                right: "-10px",
                borderRadius: "7px",
              }}
            />
          </div>
        )}
      </div>
      {cart.cartItems.length === 0 ? (
        <div className=" heightOfPanelCartEmpty margin3rem">
          {table ? (
            <MessageBox>Sipariş Yok</MessageBox>
          ) : isCustomerOrder ? (
            <MessageBox>Lütfen bir sipariş seçiniz</MessageBox>
          ) : (
            <MessageBox>Lütfen bir masa seçiniz</MessageBox>
          )}
        </div>
      ) : (
        <div>
          <div
            className="scrollbar scrollbar-primary"
            style={{
              display: "flex",
              flexDirection: "column",
              overflow: "auto",
              overflowX: "hidden",
              height: "100%",
            }}
          >
            {(ozetle ? cart.summaryCartItems : cart.cartItems).map((item, i) =>
              item.relativeItem && !ozetle ? (
                <CartScreenTouchItemRelative
                  key={
                    ozetle
                      ? item.name + (item.isGift ? "true" : "false")
                      : item.itemCode
                  }
                  ozetle={ozetle}
                  item={item}
                  cart={cart}
                  setShowChangePrice={setShowChangePrice}
                  setSelectedProduct={setSelectedProduct}
                  setSelectedProductPrice={setSelectedProductPrice}
                  setSelectedIndex={setSelectedIndex}
                  setShowAddCard={(val) => {
                    if (!readOnlyCart) {
                      setShowAddCard(val);
                    }
                  }}
                  index={i}
                />
              ) : (
                <CartScreenTouchItem
                  key={
                    ozetle
                      ? item.name + (item.isGift ? "true" : "false")
                      : item.itemCode
                  }
                  isPartialPayment={isPartialPayment}
                  ozetle={ozetle}
                  item={item}
                  cart={cart}
                  setSelectedIndex={setSelectedIndex}
                  setShowAddCard={(val) => {
                    if (!readOnlyCart) {
                      setShowAddCard(val);
                    }
                  }}
                  setShowAnswerDetails={setShowAnswerDetails}
                  setAnswers={setAnswers}
                  index={i}
                  table={table}
                  relativeItems={item.answers
                    ?.flatMap((a) => a.answers)
                    .filter((a) => a && !a.product)}
                />
              )
            )}

            <div
              className="text-warning"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                margin: "0.3rem",
              }}
            >
              <h4>
                Toplam ({isPartialPayment ? cart.partialCount : cart.totalCount}{" "}
                Adet){" "}
                <span className={cart.isStaffMeal ? "isGift text-danger" : ""}>
                  {turkishCurrencyFormatterNoPrecision(
                    isPartialPayment ? cart.partialPrice : cart.totalPrice
                  )}
                </span>
              </h4>
            </div>
          </div>
          <div id="print-area"></div>
        </div>
      )}
      {cart.cartItems.length > 0 && !readOnlyCart && (
        <div
          className="bg-dark border-dark rounded"
          style={{
            alignSelf: "flex-end",
            width: "100%",
            marginTop: "auto",
          }}
        >
          {cart.cartItems.length > 0 && (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  margin: "0.3rem",
                }}
              >
                <InputGroup size="lg" style={{ marginRight: "0.6rem" }}>
                  <Form.Control
                    style={{
                      width: "30px",
                      backgroundColor: "#eee",
                      fontWeight: "bold",
                    }}
                    type="number"
                    className="border border-secondary text-dark"
                    value={cachePayment}
                    onChange={(e) => {
                      paymentCacheChangeHandler(e);
                    }}
                  />
                  <Button
                    disabled={loadingUpdate || loading}
                    variant="secondary"
                    onClick={() => {
                      setCachePayment(
                        isPartialPayment ? cart.partialPrice : cart.totalPrice
                      );
                      setPosPayment("");
                      setTipPayment("");
                    }}
                  >
                    Nakit
                  </Button>
                </InputGroup>

                <InputGroup size="lg">
                  <Form.Control
                    type="number"
                    style={{
                      width: "30px",
                      backgroundColor: "#eee",
                      fontWeight: "bold",
                    }}
                    className="border border-secondary"
                    value={posPayment}
                    onChange={(e) => {
                      paymentPosChangeHandler(e);
                    }}
                  />
                  <Button
                    disabled={loadingUpdate || loading}
                    variant="secondary"
                    onClick={() => {
                      setPosPayment(
                        isPartialPayment ? cart.partialPrice : cart.totalPrice
                      );
                      setCachePayment("");
                      setTipPayment("");
                    }}
                  >
                    POS
                  </Button>
                </InputGroup>
              </div>
            </>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              margin: "0.3rem",
              marginTop: "0.6rem",
            }}
          >
            {!isTabletOrMobile && (
              <Button
                variant="outline-primary"
                style={{ marginRight: "10px" }}
                onClick={(e) => {
                  e.preventDefault();
                  handlePrint();
                }}
              >
                <i className="fas fa-print" />
              </Button>
            )}
            <Button
              style={{ width: "100%" }}
              size="lg"
              disabled={
                loading ||
                loadingUpdate ||
                cart.cartItems.length === 0 ||
                cart.cartItems[0].approvedAt
              }
              type="button"
              variant="secondary"
              onClick={odemeyiAlHandler}
            >
              {loading ? (
                <LoadingBox inline={true}>
                  <span>Ödeme Alınıyor...</span>
                </LoadingBox>
              ) : cart.isStaffMeal ? (
                "Afiyet Olsun!"
              ) : isPartialPayment ? (
                "Kısmi Ödemeyi Al"
              ) : cart.cartItems.filter((c) => c.isPartialPaid).length > 0 ? (
                "Ödemeyi Tamamla"
              ) : (
                "Ödemeyi Al"
              )}
            </Button>
          </div>
        </div>
      )}

      {selectedIndex >= 0 &&
        cart.cartItems.length > 0 &&
        cart.cartItems[selectedIndex] && (
          <SepetItemEditor
            showAddCard={showAddCard}
            setShowAddCard={(val) => {
              if (!readOnlyCart) {
                setShowAddCard(val);
              }
            }}
            decrementProductItemHandler={decrementCartItemHandler}
            incrementProductItemHandler={incrementCartItemHandler}
            removeItemHandler={removeItemHandler}
            loadingUpdate={loadingUpdate}
            item={cart.cartItems[selectedIndex]}
            index={selectedIndex}
            ikramEtHandler={ikramEtHandler}
            setShowDivideItem={setShowDivideItem}
            setDivideFirstPart={setDivideFirstPart}
            setDivideSecondPart={setDivideSecondPart}
            ozetle={ozetle}
            setShowChangePrice={setShowChangePrice}
            setSelectedProductPrice={setSelectedProductPrice}
            setSelectedProduct={setSelectedProduct}
            setShowAnswerDetails={setShowAnswerDetails}
            setAnswers={setAnswers}
          ></SepetItemEditor>
        )}

      <ChangePriceModal
        showChangePrice={showChangePrice}
        setShowChangePrice={setShowChangePrice}
        selectedProduct={selectedProduct}
        priceChangeRate={priceChangeRate}
        setPriceChangeRate={setPriceChangeRate}
        selectedProductPrice={selectedProductPrice}
        setSelectedProductPrice={setSelectedProductPrice}
        table={table}
      />
      <SiparisBolModal
        showDivideItem={showDivideItem}
        setShowDivideItem={setShowDivideItem}
        setDivideFirstPart={setDivideFirstPart}
        setDivideSecondPart={setDivideSecondPart}
        divideFirstPart={divideFirstPart}
        divideSecondPart={divideSecondPart}
        selectedProduct={selectedProduct}
        divideCartItemHandler={divideCartItemHandler}
        siparisDivideLoading={siparisDivideLoading}
      ></SiparisBolModal>

      <AnswersDetailsModal
        answers={answers}
        showAnswerDetails={showAnswerDetails}
        setShowAnswerDetails={setShowAnswerDetails}
        item={selectedProduct}
      />
    </div>
  );
}

function getSummaryCartItems(cartItems, historic, giftFilter) {
  let summaryCartItems = [];
  cartItems
    .filter((c) => {
      if (giftFilter) {
        return !!c.isGift; //undefined false cevriliyor
      } else {
        return !c.isGift;
      }
    })
    .forEach((item) => {
      const filteredItem = historic
        ? summaryCartItems.filter((v) => v.product === item.product)
        : summaryCartItems.filter((v) => v._id === item._id);

      if (filteredItem && filteredItem.length > 0) {
        filteredItem[0].quantity2 = filteredItem[0].quantity2 + item.quantity;
        filteredItem[0].price =
          filteredItem[0].price +
          ((item.feature ? item.feature.price : 0) + item.price) *
            item.quantity;
      } else {
        summaryCartItems = [
          ...summaryCartItems,
          {
            ...item,
            isPartialPaid: false,
            price:
              ((item.feature ? item.feature.price : 0) + item.price) *
              item.quantity,
            editable: false,
            quantity: 1,
            feature: "",
            quantity2: item.quantity,
          },
        ];
      }
    });
  return summaryCartItems;
}
